export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/details/resources/computed.js